import Phaser from "phaser";

export interface BaseToastConfig {
  x: number;
  y: number;
  duration?: number;
  onClose?: () => void;
}

export abstract class BaseToast extends Phaser.GameObjects.Container {
  protected duration: number;
  protected onClose?: () => void;
  private closeTimer?: Phaser.Time.TimerEvent;
  private isClosing = false;

  constructor(scene: Phaser.Scene, config: BaseToastConfig) {
    super(scene, config.x, config.y);

    this.duration = config.duration ?? 1000;
    this.onClose = config.onClose;

    this.setVisible(false);
    this.setActive(false);

    // 중앙에서 접힌 상태
    this.setScale(1, 0);

    scene.add.existing(this);
  }

  open() {
    this.setVisible(true);
    this.setActive(true);
    this.isClosing = false;

    // 시작 상태: 세로로 접힘
    this.setScale(1, 0);

    this.scene.tweens.killTweensOf(this);

    this.scene.tweens.add({
      targets: this,
      scaleY: 1,
      duration: 220,
      ease: "Back.Out",
    });

    this.closeTimer?.remove(false);
    this.closeTimer = this.scene.time.delayedCall(this.duration, () => {
      this.close();
    });
  }

  close() {
    if (this.isClosing) return;
    this.isClosing = true;

    this.closeTimer?.remove(false);
    this.closeTimer = undefined;

    this.scene.tweens.killTweensOf(this);

    this.scene.tweens.add({
      targets: this,
      scaleY: 0,
      duration: 180,
      ease: "Back.In",
      onComplete: () => {
        this.onClose?.();
        this.destroy();
      },
    });
  }
}
